export enum ListarVeiculosTypes {
  'LOAD_REQUEST' = '@listarVeiculos/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@listarVeiculos/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@listarVeiculos/LOAD_FAILURE',

  'CLEAN_MOVIENTRADA' = '@listarVeiculos/CLEAN_MOVIENTRADA',
  'FILTER' = '@listarVeiculos/FILTER',
}

export interface IListarVeiculos {
  codVeiculo: number;
  placa: string;
  ano: number;
  codParcTransp: number;
  nomeTransportadora: string;
  nomeTipoVeiculo: string;
  ativo: boolean;
}

export interface IFilter {
  placa: string;
  nomeTransportadora: string;
  ano: number;
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface ListarVeiculosState {
  readonly data: IListarVeiculos[];
  readonly loading: boolean;
  readonly error: boolean;
  readonly pagination: Pagination;
  readonly filter: IFilter;
}
